import { Component, Inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ProductCategoryService, SubCategoryInput } from 'src/app/core/product-category.service';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { FormErrorStateMatcher, FormService } from 'src/app/core/form.service';

@Component({
  selector: 'app-product-subcategory-add-dialog',
  templateUrl: './product-subcategory-add-dialog.component.html',
  styleUrls: ['./product-subcategory-add-dialog.component.scss'],
})
export class ProductSubcategoryAddDialogComponent {
  product_category_id?: string;
  product_subcategory_new_subcategory_from_group: FormGroup =
    this.form_service.product_subcategory_new_subcategory_from_group;
  is_submit_running: boolean = false;
  error_matcher: FormErrorStateMatcher = this.form_service.matcher;

  constructor(
    private dialog_ref: MatDialogRef<ProductSubcategoryAddDialogComponent>,
    private form_service: FormService,
    private product_category_service: ProductCategoryService,
    private error_service: ErrorService,
    @Inject(MAT_DIALOG_DATA) data: any,
  ) {
    this.product_category_id = data.product_category_id;
  }

  ngOnInit(): void {
    this.product_subcategory_new_subcategory_from_group.reset({
      ecommerce_default: false,
    });
  }

  isFormValid(): boolean {
    return this.form_service.validateForm(this.product_subcategory_new_subcategory_from_group);
  }

  onCloseClick(): void {
    this.dialog_ref.close();
  }

  onSubmitClick(): void {
    if (this.isFormValid()) {
      const name: string = this.product_subcategory_new_subcategory_from_group.get(
        this.form_service.product_subcategory_name_label,
      )?.value;

      const ecommerce_default: boolean = this.product_subcategory_new_subcategory_from_group.get(
        this.form_service.product_subcategory_ecommerce_default_label,
      )?.value;

      const params: SubCategoryInput = {
        name: name,
        ecommerce_default: ecommerce_default,
      };

      this.addSubCategory(params);
    }
  }

  addSubCategory(product_subcategory: SubCategoryInput): void {
    if (this.product_category_id) {
      this.is_submit_running = true;
      this.product_category_service.addSubCategory(this.product_category_id, product_subcategory).subscribe({
        next: () => {
          this.dialog_ref.close({ success: true });
          this.is_submit_running = false;
        },
        error: error => {
          const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
          this.dialog_ref.close({ error: processed_error });
          this.is_submit_running = false;
        },
      });
    }
  }
}
